import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { PaginationType } from "../../../dto/Pagination.dto";
import { showErrorToast, showSuccessToast } from "../../../app/utils/common/Toast";
import { createUserAPI, deleteUserAPI, getAllUserManagementAPI, getAllUsersAPI, updateUserAPI } from "../../API/AllUsersAPI";
import { AllUsersSliceState } from "../../Slices/allUsersSlice";
import { AllUsersType } from "../../../dto/AllUsers.dto";
import { UserManagementType } from "../../../dto/User.dto";
import { stat } from "fs";
import { showErrorResponse } from "../../../app/utils/common/showErrorMessage";

export const AllUsersReducer = (
  builder: ActionReducerMapBuilder<AllUsersSliceState>
) => {
  builder
    .addCase(getAllUsersAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      getAllUsersAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          user_data: AllUsersType[];
          pagination: PaginationType;
          role_id: number;
        }>
      ) => {
        if (
          action.payload.pagination.current_page ===
          state.pagination.current_page
        ) {
          //   if (action.payload.status === "pending") {
          state.allUsers = action.payload?.user_data;
          state.pagination = action.payload.pagination;
          //   }
          //   state.pagination = action.payload.pagination;
          state.loading = false;
        }
      }
    )
    .addCase(getAllUsersAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })


    .addCase(getAllUserManagementAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      getAllUserManagementAPI.fulfilled,
      (
        state,
        action: PayloadAction<{
          user_data: UserManagementType[];
          pagination: PaginationType;
          // role_id: number;
        }>
      ) => {
        if (
          action.payload.pagination.current_page ===
          state.userManagementPagination.current_page
        ) {
          //   if (action.payload.status === "pending") {
          state.UserManagement = action.payload?.user_data;
          state.userManagementPagination = action.payload.pagination;
          //   }
          //   state.pagination = action.payload.pagination;
          state.loading = false;
        }
      }
    )
    .addCase(getAllUserManagementAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })

    .addCase(createUserAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      createUserAPI.fulfilled,
      (
        state,
        action: PayloadAction<{ user_data: UserManagementType[]; pagination: PaginationType; }>) => {
        state.loading = false;
        showSuccessToast("User created successfully.");
        state.UserManagement = [];
      }
    )
    .addCase(createUserAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })


    .addCase(updateUserAPI.pending, (state) => {
      state.loading = true;
    })
    .addCase(
      updateUserAPI.fulfilled,
      (
        state,
        action: PayloadAction<{ user_data: UserManagementType[]; pagination: PaginationType; }>) => {
        state.loading = false;
        showSuccessToast("User updated successfully.");
        state.UserManagement = [];
      }
    )
    .addCase(updateUserAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    })

    .addCase(
      deleteUserAPI.fulfilled,
      (
        state,
        action: PayloadAction<any>
      ) => {
        state.loading = false;
        showSuccessToast("User deleted successfully.");
      }
    )
    .addCase(deleteUserAPI.rejected, (state, action: PayloadAction<any>) => {
      showErrorResponse(action.payload);
    });



};
